<template>
  <section class="container mx-auto px-2 my-4">
    <h1 class="dark:text-white font-light text-2xl tracking-wide mb-2">
      {{ config.slogan ?? t("Gather ⋅ Organize ⋅ Mobilize") }}
    </h1>
    <p class="dark:text-gray-400 text-sm font-light">{{ config.description }}</p>
  </section>
</template>
<script lang="ts" setup>
import { IConfig } from "@/types/config.model";
import { useI18n } from "vue-i18n";
defineProps<{
  config: Pick<
    IConfig,
    "name" | "description" | "slogan" | "registrationsOpen"
  >;
}>();
const { t } = useI18n({ useScope: "global" });
</script>
